import { WinLabel } from '@/containers/winnings/WinLabel'
import { WinCombination } from '@/modules'
import GameSignals from '@/signals/GameSignals'
import { BaseContainer } from '@base/base/BaseContainer'
import { ReelsContainerHelper } from '@/containers/reels/ReelsContainerHelper'
import Facade from '@/Facade'
import { WinLabelsPool } from '@/factories/Factory'
import gsap from 'gsap'

export class ShowWinnings extends BaseContainer {
    private _activeLabels: WinLabel[]
    private _labelsPositions: number[][]

    public constructor() {
        super()

        GameSignals.showWinLabels.connect(this.onShowWinLabels)

        this._activeLabels = []
        this._labelsPositions = []
    }

    private onShowWinLabels = (winCombinations: WinCombination[]) => {
        winCombinations.forEach((combination: WinCombination) => {
            if (!combination.win_currency) {
                return
            }
            
            const label: WinLabel = WinLabelsPool.out(this)
            this._activeLabels.push(label)

            label.changeValue(combination.win_currency)
            const labelPosition: {x: number, y: number} = this.getLabelPosition(combination)
            label.position.set(labelPosition.x, labelPosition.y)
            label.visible = false

            gsap.to(label, {
                duration: 0.5,
                onComplete: () => {
                    label.showLabel()
                }
            })
        })

        gsap.to(this, {
            duration: 1,
            onComplete: () => {
                this._activeLabels.forEach((label: WinLabel) => {
                    label.hideLabel(() => {
                        WinLabelsPool.in(label)
                    })
                })
                this._labelsPositions = []
                this._activeLabels = []
            }
        })
    }

    private getLabelPosition = (combination: WinCombination): {x: number, y: number} => {
        const result: {x: number, y: number} = { x: 0, y: 0}
        const positions: number[][][] = [[], [], [], []]
        let position: number[]

        combination.symbols_positions.forEach((position: number[]) => {
            if (!position) { // TODO sometimes it's happen
                position = [3, 3]
            }

            if (position[1] === 1 || position[1] === 2 || position[1] === 3) {
                position[0] === 2 || position[0] === 3 ? positions[0].push(position) : positions[1].push(position)
                return
            }

            position[0] === 2 || position[0] === 3 ? positions[2].push(position) : positions[3].push(position)
        })

        position = this.getFinalPosition(positions[0]) || this.getFinalPosition(positions[1]) ||
            this.getFinalPosition(positions[2]) || this.getFinalPosition(positions[3])

        if (!position) { //Case when all positions are filled
            this._labelsPositions = []

            position = this.getFinalPosition(positions[0]) || this.getFinalPosition(positions[1]) ||
                this.getFinalPosition(positions[2]) || this.getFinalPosition(positions[3])
        }

        this._labelsPositions.push(position)

        result.x = ReelsContainerHelper.calculateReelWidth() * position[0] + (Facade.symbolsConfig.WIDTH / 2)
        result.y = ReelsContainerHelper.calculateReelHeight() * position[1] + (Facade.symbolsConfig.HEIGHT / 2)

        return result
    }

    private getFinalPosition = (positions: number[][]): number[] => {
        if (positions.length && !this.arraysAreEqual(positions, this._labelsPositions)) {
            let position = positions[0]

            for (const _index in positions) {
                if (this._labelsPositions.some(subArray =>
                    subArray.length === position.length &&
                    subArray.every((value, index) => value === position[index]))) {
                        position = positions[+_index + 1]
                } else {
                    break
                }
            }

            return position
        }

        return null
    }


    private arraysAreEqual = (arr1: number[][], arr2: number[][]): boolean => {
        if (arr1.length !== arr2.length) {
            return false
        }

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i].length !== arr2[i].length || !arr1[i].every((value, index) => value === arr2[i][index])) {
                return false
            }
        }

        return true
    }
}
